export interface CustomFieldDefinition {
    id: string;
    entity_type: string;
    display_name: string;
    name: string;
    /** Some entities (e.g. cargo items) key their custom field values by this instead of `name` */
    internal_name?: string;
    data_type: string;
}
